/*
 *  Module for the search control
*/

rs.module("ui/controls/content/search",

    ["controls/data/grid", "ui/framework/client-templates", "controls/data/masked-data"],

    function (gridModule, clientTemplates, maskedData) {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, clientTemplateKeys, backendUrls, queryAxes, columnIds, searchResultsGridLrsApi, recentSearchesApi) {

            var onSelectionCompleteCallback;
            var onSelectionClearedCallback

            var search = $.js(jsSelectors.search);
            var popup = $.js(jsSelectors.popup);

            // Trigger search when search button is clicked
            search.js(jsSelectors.searchButton).click(initiateSearch);

            // Trigger search when pressing Enter inside search input
            search.js(jsSelectors.searchInput).on("keydown",
                function (event) {
                    if (event.which == 13) {
                        initiateSearch();

                        // by default forms will submit when Enter is pressed, this suppresses that behavior
                        return false;
                    }
                }
            );

            // On search results row clicked, populates the search control with selected result
            searchResultsGridLrsApi.selectionChanged(function (values, rows) {
                // need to make sure values is greater than zero because grid.selectionChanged fires when grid is first rendered
                if (values.length > 0) {

                    // The TIN column is a masked value, so it is an array with the actual masked text being in slot 1 and cipher in 0.
                    initializeControlForSelectedValue(values[0], rows[0][columnIds.name], rows[0][columnIds.tin][1], rows[0][columnIds.tin][0]);
                }
            });

            // On recent search link clicked, populates the search control with selected result
            if (recentSearchesApi) {
                recentSearchesApi.onRecentSearchLinkClick(function (participant) {

                    initializeControlForSelectedValue(participant[columnIds.primarykey], participant.name, participant.tin, participant.tincipher);

                    // need to return false so the recent search link doesn't redirect to the result's home page
                    return false;
                });
            }

            // On 'X' token icon clicked, clear the selected result
            search.on("click", `[data-js~=${jsSelectors.clearSelectionIcon}]`, function () {

                // clear selected value
                search.js(jsSelectors.selectedValueHidden).val(null);

                // remove token from search overlay
                search.js(jsSelectors.overlayContent).empty();

                // hide overlay and show search input
                showOverlay(false, true);

                search.js(jsSelectors.searchInput).focus();

                // if callback was provided execute selection cleared callback 
                if (onSelectionClearedCallback) {
                    onSelectionClearedCallback.call(search);
                }
            });

            // Hide only this modal on close.
            popup.js(jsSelectors.popupCloseButton).on('click', function () {
                // hide the popup 
                popup.modal("hide");
            });

            // On popup close, determine whether to show the overlay or the search input
            $.js(jsSelectors.popup).on('hide.bs.modal', function (e) {

                var show = search.js(jsSelectors.selectedValueHidden).val() != "";
                showOverlay(show, !show);
            });

            //
            // Initiate the search
            //
            function initiateSearch() {

                // show loading spinner
                search.js(jsSelectors.spinner).show();

                // copy search text into overlay and show overlay
                search.js(jsSelectors.overlayContent).html(search.js(jsSelectors.searchInput).val());
                showOverlay(true);

                var query = search.js(jsSelectors.searchInput).val().trim();

                gridModule.update(
                    backendUrls.search,
                    {
                        query: query + (query != "" ? queryAxes : ""),
                        nameColumnId: columnIds.name,
                        tinColumnId: columnIds.tin,
                    },
                    searchResultsGridLrsApi.agGridApi,
                    function done() {

                        // hide loading spinner
                        search.js(jsSelectors.spinner).hide();

                        // show the popup 
                        $.js(jsSelectors.popup).modal("show");
                    }
                );
            }

            //
            // Saves the selected value and displays the selected token in the search overlay
            //
            function initializeControlForSelectedValue(selectedValue, name, tin, cipher) {

                // save selected value to hidden input
                search.js(jsSelectors.selectedValueHidden).val(selectedValue);

                // clear any errors
                search.js(jsSelectors.selectedValueHidden).clearErrors();

                // clear search input
                search.js(jsSelectors.searchInput).val(null);

                // show the search overlay that will hold our token
                showOverlay(true);

                // add token for selected person
                search.js(jsSelectors.overlayContent).html($(clientTemplates.render(clientTemplateKeys.token, { name: name, tin: maskedData.applyBulletStyling(tin), cipher: cipher })));

                // hide the popup 
                $.js(jsSelectors.popup).modal("hide");

                // if callback was provided execute selection complete callback 
                if (onSelectionCompleteCallback) {
                    onSelectionCompleteCallback.call(search, selectedValue);
                }
            }

            //
            // Helper function to toggle the display of the search overlay vs. actual search input
            //
            function showOverlay(showOverlay, setFocus) {

                // show/hide search input
                search.js(jsSelectors.searchInput).toggleClass(cssClasses.hidden, showOverlay);

                if (!showOverlay && setFocus) {
                    search.js(jsSelectors.searchInput).focus();
                }

                // show/hide search overlay
                search.js(jsSelectors.searchOverlay).toggleClass(cssClasses.hidden, !showOverlay);

                // disable/enable search button
                search.js(jsSelectors.searchButton).setDisabled(showOverlay);
            }

            //
            // API function to allow consumers to provide a callback to execute when a search selection has been made
            //
            function onSelectionComplete(onSelectionComplete) {
                onSelectionCompleteCallback = onSelectionComplete;
            }

            //
            // API function to allow consumers to provide a call back function to execute if the selection is cleared
            //
            function onSelectionCleared(onSelectionCleared) {
                onSelectionClearedCallback = onSelectionCleared;
            }

            //
            // API function to allow consumers to clear the search control
            //
            function clear() {

                // clear search input
                search.js(jsSelectors.searchInput).val(null);

                // clear selected value
                search.js(jsSelectors.selectedValueHidden).val(null);

                // remove token from search overlay
                search.js(jsSelectors.overlayContent).empty();

                // hide overlay and show search input
                showOverlay(false, false);

                // if callback was provided execute selection cleared callback 
                if (onSelectionClearedCallback) {
                    onSelectionClearedCallback.call(search);
                }
            }

            //
            // API function to allow consumers to return the selected value of the search control
            //
            function getValue() {
                return search.js(jsSelectors.selectedValueHidden).val();
            }

            // Exported instance API
            return {
                onSelectionComplete,
                onSelectionCleared,
                clear,
                getValue
            };
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);